import googleMap from "./social/googlemap.png";
import instagram from "./social/instagram.png";
import linkedin from "./social/linkedin.png";
import twitter from "./social/twitter.png";
import whatsapp from "./social/whatsapp.png";
import cvstudio from "./theme1_CV_Studio.png";
import mirror from "./theme1_Mirror.png";
import milestone from "./theme1_Milestone.png";
import layer from "./theme1_Layers.png";
import pdfImage from "./pdf.png";
import notificationIcon from "./notificationIcon.svg";
import familyMemberIcon from "./familyMemberIcon.svg";
import helpCenterIcon from "./helpCenter.svg";
import logOutIcon from "./logOutIcon.svg";
import selectedAllDoxIcon from "./selectedAllDox11.svg";
import selectedHomeIcon from "./selectedHome_theme1.svg";
import selectedBusinessCardTabIcon from "./selectedBusinessCardTab.svg";
import selectedFavouriteIcon from "./selectedFavourite.svg";
import cyp_theme from "./cyp_theme8.svg";
import settingIcon from "./settingIcon.svg";
import shareIcon from "./shareIcon.svg";


import bankAccountIcon from './docTypeIcons/DoxBox Icon/Bank Account Details.svg';
import OtherDox from './docTypeIcons/DoxBox Icon/OtherDox.svg';
import baptismIcon from './docTypeIcons/DoxBox Icon/Baptism Certificate.svg';
import birthCertificateIcon from './docTypeIcons/DoxBox Icon/Birth Certificate.svg';
import bookingHotelIcon from './docTypeIcons/DoxBox Icon/Booking.svg';
import carInsuranceIcon from './docTypeIcons/DoxBox Icon/Insurance.svg';
import deathCertificateIcon from './docTypeIcons/DoxBox Icon/Death Certificate.svg';
import degreeCardIcon from './docTypeIcons/DoxBox Icon/Degrees and Certificates.svg';
import divorceCertificateIcon from './docTypeIcons/DoxBox Icon/Divorce Certificate.svg';
import drivingLicenceDetailIcon from './docTypeIcons/DoxBox Icon/Driver’s Licence.svg';
import employmentCardIcon from './docTypeIcons/DoxBox Icon/Employment Contracts.svg';
import idCardIcon from './docTypeIcons/DoxBox Icon/ID.svg';
import insuranceIcon from './docTypeIcons/DoxBox Icon/Insurance.svg';
import itineraryIcon from './docTypeIcons/DoxBox Icon/Airline Ticket.svg';
import loyaltyCardDetailIcon from './docTypeIcons/DoxBox Icon/Loyalty Card.svg';
import marriageCardIcon from './docTypeIcons/DoxBox Icon/marriage certificate.svg';
import passportIcon from './docTypeIcons/DoxBox Icon/Airline Ticket.svg';
import photoPassportIcon from './docTypeIcons/DoxBox Icon/Photo Passport.svg';
import residencyVisaIcon from './docTypeIcons/DoxBox Icon/Residency & Visa.svg';
import resumeCoverLetterIcon from './docTypeIcons/DoxBox Icon/Resume & Cover letter.svg';
import tenancyContractIcon from './docTypeIcons/DoxBox Icon/Tenancy Contract & Title Deed.svg';
import vaccinationIcon from './docTypeIcons/DoxBox Icon/Vaccination Card.svg';
import willIcon from './docTypeIcons/DoxBox Icon/Will.svg';

import businessCardBackground from './businessCardBackground.png';

const images = {
  googleMap,
  instagram,
  linkedin,
  twitter,
  whatsapp,
  notificationIcon,
  familyMemberIcon,
  helpCenterIcon,
  logOutIcon,
  selectedAllDoxIcon,
  selectedHomeIcon,
  selectedBusinessCardTabIcon,
  selectedFavouriteIcon,
  cvstudio,
  milestone,
  layer,
  mirror,
  cyp_theme,
  settingIcon,
  shareIcon,
  pdfImage,
  businessCardBackground,
};

export const DOC_TYPE_ICONS = {
  bank_account: bankAccountIcon,
  baptism: baptismIcon,
  birth_certificate: birthCertificateIcon,
  booking_hotel: bookingHotelIcon,
  car_insurance: carInsuranceIcon,
  death_certificate: deathCertificateIcon,
  degree_card: degreeCardIcon,
  divorce_certificate: divorceCertificateIcon,
  driving_licence_detail: drivingLicenceDetailIcon,
  employmentCard: employmentCardIcon,
  idCard: idCardIcon,
  insurance: insuranceIcon,
  itinerary: itineraryIcon,
  loyalty_card_detail: loyaltyCardDetailIcon,
  marriageCard: marriageCardIcon,
  passport: passportIcon,
  photo_passport: photoPassportIcon,
  residency_visa: residencyVisaIcon,
  resume_cover_letter: resumeCoverLetterIcon,
  tenancy_contract: tenancyContractIcon,
  vaccination: vaccinationIcon,
  will: willIcon,
  OtherDox:OtherDox
}

export default images;
